import BaseForm from '../base';
import { LatLongColumnsComponent } from '../components';
export class RcuForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent({ validate: { required: true } }),
        ];
    }
}
